import { useEffect, useRef } from 'react';
import { useProjectStore } from '../../../store/projectStore';
import { useLogicStore } from '../../../store/logicStore';
import { solveNetworkLogic } from '../../../engine/networkLogic';

const DEBOUNCE_MS = 200;

export function LogicSimulationHost() {
  const design = useProjectStore((s) => s.getCurrentDesign());
  const mode = design?.logicMode === 'logic' ? 'logic' : 'plan';
  const setResult = useLogicStore((s) => s.setResult);
  const timer = useRef<number | null>(null);

  const eqKey = JSON.stringify((design?.equipment || []).map((e) => [e.id, e.config, e.equipment.id]));
  const cableKey = JSON.stringify((design?.cables || []).map((c) => [c.id, c.from, c.to, c.type, c.subtype, c.hidden]));
  const rackKey = JSON.stringify((design?.racks || []).map((r) => [r.id, r.equipment]));

  useEffect(() => {
    if (mode !== 'logic' || !design) {
      setResult(null);
      return;
    }
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => {
      const d = useProjectStore.getState().getCurrentDesign();
      if (!d || d.logicMode !== 'logic') {
        setResult(null);
        return;
      }
      setResult(solveNetworkLogic(d));
    }, DEBOUNCE_MS);
    return () => {
      if (timer.current) window.clearTimeout(timer.current);
    };
  }, [mode, eqKey, cableKey, rackKey, setResult, design]);

  return null;
}
